// Skapa en ny fil för våra valideringsfunktioner

/**
 * Grupperar siffrorna efter riktnumret enligt svensk standard: jämnt antal
 * siffror blir par, udda antal får en trea först.
 *   7 siffror -> 123 45 67      6 siffror -> 12 34 56
 */
const gruppera = (siffror) => {
  const grupper = [];
  let rest = siffror;
  if (rest.length % 2 === 1) {
    grupper.push(rest.slice(0, 3));
    rest = rest.slice(3);
  }
  for (let i = 0; i < rest.length; i += 2) grupper.push(rest.slice(i, i + 2));
  return grupper.join(' ');
};

export const validatePhone = (phone) => {
  // Tillåt tomt telefonnummer
  if (!phone || phone.trim() === '') {
    return { isValid: true, formattedValue: '', message: '' };
  }

  // Tillåt svenska mobilnummer och fasta nummer
  // Mobil: 07X XXX XX XX, 07XXXXXXXX, 07X-XXX XX XX
  // Fast: 08-XXXXXXX, 08 XXXXXXX, 031-XXXXXX, 040 XXXXXXX, etc
  let clean = phone.replace(/[\s\-()]/g, '');

  // +46 och 0046 är samma nummer som 0-formen — normalisera så de också
  // formateras i stället för att avvisas som ogiltiga.
  clean = clean.replace(/^\+46/, '0').replace(/^0046/, '0');

  const mobileRegex = /^07\d{8}$/;
  const landlineRegex = /^0\d{1,3}\d{5,8}$/;

  if (mobileRegex.test(clean)) {
    // 0735218986 -> 073 521 89 86
    const formatted = clean.replace(/(07\d)(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
    return { isValid: true, formattedValue: formatted, message: '' };
  }

  if (landlineRegex.test(clean)) {
    // Riktnumret avgör var första mellanslaget hamnar. Bara 08 (Stockholm)
    // grupperas automatiskt — riktnummer är 2–4 siffror långa och det finns
    // inget sätt att gissa längden ur numret självt. Ett felgissat riktnummer
    // ger ett nummer som ser rätt ut men är felgrupperat, vilket är värre än
    // att lämna det orört. Övriga fasta nummer städas bara från bindestreck.
    if (/^08\d{6,8}$/.test(clean)) {
      // 08-1234567 -> 08 123 45 67
      return { isValid: true, formattedValue: `08 ${gruppera(clean.slice(2))}`, message: '' };
    }
    const formatted = phone.replace(/-/g, ' ').replace(/\s+/g, ' ');
    return { isValid: true, formattedValue: formatted.trim(), message: '' };
  }

  return {
    isValid: false,
    formattedValue: phone,
    message: 'Ogiltigt telefonnummer. Ange mobil (07...) eller fast nummer (t.ex. 08-1234567)'
  };
};

/**
 * Formaterar ett telefonnummer och returnerar enbart strängen — för ställen som
 * vill snygga till numret utan att bry sig om giltigheten. Går numret inte att
 * tolka returneras det oförändrat, så inget skrivs sönder.
 */
export const formateraTelefonnummer = (phone) => validatePhone(phone).formattedValue || phone || '';

// Lägg till övriga valideringsfunktioner här
export const validatePostCode = (postCode) => {
  const cleanPostCode = postCode.replace(/\D/g, '');
  if (cleanPostCode.length !== 5) {
    return { isValid: false, message: 'Postnummer måste innehålla 5 siffror' };
  }
  return { 
    isValid: true, 
    formattedValue: cleanPostCode.replace(/(\d{3})(\d{2})/, '$1 $2') 
  };
};

export const validateProjectName = (projectName) => {
  const projectNameRegex = /^\d{5}$/;
  if (!projectNameRegex.test(projectName)) {
    return { isValid: false, message: 'Projektnamn måste vara 5 siffror (t.ex. 41293)' };
  }
  return { isValid: true };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, message: 'Ange en giltig e-postadress' };
  }
  return { isValid: true };
};

export const validateUrl = (url) => {
  if (!url) return { isValid: true }; // Tillåt tomt fält
  
  try {
    new URL(url);
    return {
      isValid: true,
      formattedValue: url
    };
  } catch {
    return {
      isValid: false,
      message: 'Ogiltig URL. Måste börja med http:// eller https://',
      formattedValue: url
    };
  }
};
